import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Badge from "../common/Badge";
import { SkeletonRow } from "../common/Skeleton";
import { formatDate } from "../../utils/format";

export default function StudentTable({ students, loading }) {
  return (
    <div className="pm-table-wrap">
      <table className="pm-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Student ID</th>
            <th>Email</th>
            <th>University</th>
            <th>Specialisation</th>
            <th>Qualification</th>
            <th>Applied</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {loading &&
            Array.from({ length: 6 }).map((_, i) => <SkeletonRow key={i} />)}

          {!loading &&
            students.map((s, i) => (
              <motion.tr
                key={s.id}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.25, delay: Math.min(i, 8) * 0.02 }}
              >
                <td className="pm-table__primary">{s.name}</td>
                <td>{s.student_id}</td>
                <td className="pm-table__muted">{s.email_id}</td>
                <td>{s.university_name}</td>
                <td>{s.specialisation || "—"}</td>
                <td>{s.education_qualification || "—"}</td>
                <td>{formatDate(s.applied_date)}</td>
                <td>
                  {/* s.is_active comes back from student_details (an ENUM('1','0')
                      column) as the STRING "1" or "0" — !!"0" is true in JS,
                      so this must compare the real value, not just truthiness. */}
                  <Badge active={Number(s.is_active) === 1} />
                </td>
                <td>
                  <Link to={`/admin/students/${s.id}`} className="pm-table__link">
                    View →
                  </Link>
                </td>
              </motion.tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}